import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { CustomCursor } from './Motion';
import SmoothScroll from './SmoothScroll';

export default function Layout({ children }) {
  return (
    <SmoothScroll>
      <div className="min-h-screen relative grain" style={{ background: 'var(--bg)' }}>
        <CustomCursor />
        <Navbar />
        <main className="pt-[76px]">{children}</main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
